import { render, staticRenderFns } from "./AppTextField.vue?vue&type=template&id=38c986a5&scoped=true&"
import script from "./AppTextField.vue?vue&type=script&lang=ts&"
export * from "./AppTextField.vue?vue&type=script&lang=ts&"
import style0 from "./AppTextField.vue?vue&type=style&index=0&id=38c986a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c986a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VTextField})
